import { addYears } from "@fluentui/react-calendar-compat";
import { useMutation } from "@tanstack/react-query";
import { SearchState } from "Pages/Search/index.types";
import { OnDemandDatasets } from "Utils";
import { AxiosResponse } from "axios";
import {
  HttpClient,
  ServiceProvider,
  useBigDataCorpConfig as useGetConfig,
} from "config/httpClient";
import moment from "moment";
import { ApiResponse } from "types/OnDemand.types";

export const getProcessosJudiciais = async ({
  searchParams: { doc },
  comprot: { searchInterval },
}: SearchState) => {
  const today = new Date();
  const to = moment(today).format("DD/MM/YYYY");
  const from = moment(addYears(today, -searchInterval)).format("DD/MM/YYYY");
  let payload: any = {
    dataset: OnDemandDatasets.Processes,
    cnpj: doc,
    startdate: from,
    enddate: to,
    // q: `doc\{${doc}\},startdate\{${from}\},enddate\{${to}\},dateformat{dd/MM/yyyy},returnUpdates{false}`,
  };
  return HttpClient(ServiceProvider.NinApi).post<ApiResponse>(
    "search/processes",
    payload,
  );
};

export const useProcessosJudiciais = (
  onSuccess: (
    data: AxiosResponse,
    variables: SearchState,
    context: unknown,
  ) => void,
) =>
  useMutation({
    mutationFn: getProcessosJudiciais,
    onSuccess,
    retry: 1,
  });
